import { httpGet, httpPost, httpPut, httpDelete, httpGetFile } from './api.service';
import { GetNearFacilitieRequest } from '../requestModels/facilityRequest';
import { PaginatedRequest } from '../requestModels/paginatedRequest';
import { PaginatedResult } from '../types/PaginatedResult';
import { Facility } from '../types/Facility';
import { ChangeLog } from '../types/ChangeLog';
import { SingleResult } from '../types/SingleResult';
import { AddCarrierPayload, Carrier } from '../types/Carrier';

const getCarriers = async (request: PaginatedRequest): Promise<SingleResult<PaginatedResult<Carrier>>> => {
  return await httpGet<SingleResult<PaginatedResult<Carrier>>>(`api/carrier`, {
    ...request,
    take: 99999,
  });
};

const addCarriers = async (facilityId: string, payload: AddCarrierPayload) => {
  return await httpPut(`api/facility/${facilityId}/carrier`, payload);
};

const deleteCarriers = (facilityId: string, payload: { carrierIds: string[] }) => {
  return httpDelete(`api/facility/${facilityId}/carrier`, payload);
};

const getFacilities = async (request: PaginatedRequest): Promise<SingleResult<PaginatedResult<Facility>>> => {
  return await httpGet<SingleResult<PaginatedResult<Facility>>>(`api/facility`, request);
};

const exportFacilities = async (request: PaginatedRequest): Promise<void> => {
  return await httpGetFile(`api/facility/export`, request);
};

const getNearFacilities = async (request: GetNearFacilitieRequest): Promise<SingleResult<PaginatedResult<Facility>>> => {
  return await httpGet<SingleResult<PaginatedResult<Facility>>>(
    `api/facility/near/${request.lat}/${request.lng}/${request.distanceInMeters}/${request.skip ?? 0}/${request.take ?? 20}`,
  );
};

const getFacilityById = async (id: string): Promise<SingleResult<PaginatedResult<Facility>>> => {
  return await httpGet<SingleResult<PaginatedResult<Facility>>>(`api/facility/${id}`);
};

const addFacility = async (request: Facility): Promise<Facility> => {
  return await httpPost(`api/facility`, request);
};

const updateFacility = async (request: Facility): Promise<Facility> => {
  return await httpPut(`api/facility`, request);
};

const deleteFacility = async (id: string): Promise<boolean> => {
  return await httpDelete(`api/facility/${id}`);
};

const getFacilityChangeLog = async (id: string, request: PaginatedRequest): Promise<SingleResult<PaginatedResult<ChangeLog>>> => {
  return await httpGet<SingleResult<PaginatedResult<ChangeLog>>>(`api/facility/${id}/changeLog`, request);
};

export {
  getFacilities,
  exportFacilities,
  getNearFacilities,
  getFacilityById,
  addFacility,
  updateFacility,
  deleteFacility,
  getFacilityChangeLog,
  getCarriers,
  addCarriers,
  deleteCarriers,
};
